/**
 * Lazy route registration for the position wizard surfaces (Plan 02-07).
 *
 * Pairs with the i18n ``bindI18n`` + ``preload`` config in ``lib/i18n.ts`` so
 * the wizard / positions / common namespaces render in the right language on
 * first navigation (BUG-003).
 */
import { lazy } from "react";

export const PositionWizardRoute = lazy(() =>
  import("@/features/positions/wizard/PositionWizard").then((m) => ({
    default: m.PositionWizard,
  })),
);

export const ActivateSuccessScreenRoute = lazy(() =>
  import("@/features/positions/ActivateSuccessScreen").then((m) => ({
    default: m.ActivateSuccessScreen,
  })),
);

export const PositionDetailPageRoute = lazy(() =>
  import("@/features/positions/PositionDetailPage").then((m) => ({
    default: m.PositionDetailPage,
  })),
);
